import React from 'react';
import CollectedAFWebSite from '../components/CollectedAFWebSite';

/**
 * Home Page
 * Main landing page for the application
 */
const HomePage: React.FC = () => {
  return <CollectedAFWebSite />;
};

export default HomePage;
